import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ticket-countdown"
export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = {
    targetTime: String
  }

  connect() {
    this.updateCountdown()
    this.timer = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  updateCountdown() {
    const now = new Date().getTime()
    const targetTime = new Date(this.targetTimeValue).getTime()
    const timeLeft = targetTime - now

    if (timeLeft <= 0) {
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    // Calculate time components
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

    // Update the display
    this.daysTarget.textContent = days
    this.hoursTarget.textContent = hours
    this.minutesTarget.textContent = minutes
    this.secondsTarget.textContent = seconds
  }
}
